<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>Detalle Envío Documento Traces</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">
                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigo">Id Solicitud</label>
                                <input formControlName="IdSolicitud" numbersOnly name="IdSolicitud" title=""
                                       class="form-control" id="inpNombre" type="text" value="" maxlength="9" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaInicioCompleta">Fecha Inicio</label>
                                <input formControlName="FechaInicioCompleta" name="FechaInicioCompleta" title=""
                                       class="form-control" id="inpFechaInicioCompleta" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaFinCompleta">Fecha Envío</label>
                                <input formControlName="FechaFinCompleta" name="FechaFinCompleta" title=""
                                       class="form-control" id="inpFechaFinCompleta" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigo">Duración (ms)</label>
                                <input formControlName="Duracionms" numbersOnly name="Duracionms" title=""
                                       class="form-control" id="inpDuracionms" type="number" value="" readonly>
                            </div>



                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigoSolicitud">Código Solicitud</label>
                                <input formControlName="CodigoSolicitud" name="CodigoSolicitud" title=""
                                       class="form-control" id="inpCodigoSolicitud" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpEstadoSolicitud">Estado Solicitud</label>
                                <input formControlName="EstadoSolicitud" name="EstadoSolicitud" title=""
                                       class="form-control" id="inpEstadoSolicitud" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpChedPp">CHED PP</label>
                                <input formControlName="ChedPp" name="ChedPp" title=""
                                       class="form-control" id="inpChedPp" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDocumento">Documento</label>
                                <input formControlName="Documento" name="Documento" title=""
                                       class="form-control" id="inpDocumento" type="text" value="" readonly>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpIdDocumentoSolicitud">Id DocumentoSolicitud</label>
                                <input formControlName="IdDocumentoSolicitud" name="IdDocumentoSolicitud" title=""
                                       class="form-control" id="inpIdDocumentoSolicitud" type="text" value="" readonly>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpReferenciaTraces">Referencia TRACES</label>
                                <input formControlName="ReferenciaTraces" name="ReferenciaTraces" title=""
                                       class="form-control" id="inpReferenciaTraces" type="text" value="" readonly>
                            </div>




                        </div>

                      
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpDescripcionError">Error</label>
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button name="btnCopiarError" class="btn btn-list btn-secondary" type="button" title="Copiar"
                                                (click)="onCopiarError(descripcionerror)">
                                            <i class="fa fa-copy"></i>
                                        </button>&nbsp;
                                    </span>
                                    <input formControlName="DescripcionError" name="DescripcionError" title="" #descripcionerror
                                           class="form-control" id="inpDescripcionError" type="text" value="" readonly>
                                </div>
                            </div>
                        </div>



                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpSoapResponse">Soap Response</label>
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button name="btnCopiarSoapResponse" class="btn btn-list btn-secondary" type="button" title="Copiar"
                                                (click)="onCopiarSoapResponse(soapresponse)">
                                            <i class="fa fa-copy"></i>
                                        </button>&nbsp;
                                    </span>
                                    <textarea style="resize:none" rows="10" readonly formControlName="SoapResponse" #soapresponse
                                           class="form-control" id="inpSoapResponse" type="text" value=""></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
